import { Component } from '@angular/core';

@Component({
  selector: 'i-checkmark',
  imports: [],
  templateUrl: './i-checkmark.html',
  host: {
    class: 'grid place-items-center',
  },
})
export class ICheckmark {}
